import React from 'react';
import { Link } from 'react-router-dom';
import 'whatwg-fetch';
import { itemsPerPage } from 'src/data/params';

import ModalLinkProductToOrder from './modalLinkProductToOrder';
import ModalConfirm from '../components/modal/modalConfirm';

import hardwareIcon from '../../images/icons/hardware.svg';
import virtualIcon from '../../images/icons/virtual.svg';
import SubNavBar from '../components/SubNavBar';
import withAuth from 'src/hoc/withAuth';

const linkToProductHardware = '/dashboard/productHardware/';
const linkToProductVirtual = '/dashboard/productVirtual/';
const apiDealShow = '/api/deal/show/';
const apiProductLink = '/api/stepProduction/associateProduct/';
const apiProductsLink = '/api/stepProduction/associateProducts/';
const apiProductUnLink = '/api/stepProduction/deleteProductsAssociation/';
const stepDetails = [
  { name: 'Mail client avec les documents', value: 1 },
  { name: 'Retirer les produits du stock', value: 2 },
  { name: 'Création de licences', value: 3 },
  { name: 'Attribution des SDA', value: 4 },
  { name: 'Attribution des postes', value: 5 },
  { name: "Prendre contact avec l'informaticien", value: 6 },
  { name: 'Renseigner la fiche de collecte des informations', value: 7 },
  { name: 'Définir un référent technique chez le client', value: 8 },
  { name: 'Test de ligne support', value: 9 },
];

class AppPrep extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedView: 1,
      currentStep: 1,
      textModal: {
        title: undefined,
        message: undefined,
      },
      entity: undefined, // products displayed inside the table
      dealID: undefined,
      dataAssociationHardware: undefined,
      dataAssociationVirtual: undefined,
      isModalLinkProductOpen: false,
      isModalUnLinkProductOpen: false,
      isScanMultiple: true,
      assocLinkId: undefined,
      modalLinkRefId: undefined,
      modalLinkWording: undefined,
      unLinkAssocId: undefined,
      unLinkProductId: undefined,
      accordionMenu: new Object(),
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.viewStep = this.viewStep.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.openModalLinkProduct = this.openModalLinkProduct.bind(this);
    this.openModalUnLinkProduct = this.openModalUnLinkProduct.bind(this);
    this.link = this.link.bind(this);
    this.linkProduct = this.linkProduct.bind(this);
    this.linkProducts = this.linkProducts.bind(this);
    this.unLinkProduct = this.unLinkProduct.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  componentDidMount() {
    if (this.props.match.params.id) {
      // check if id supplied in the route
      const paramsID = this.props.match.params.id;

      let queryURL = apiDealShow;
      let graphQL =
        '{ deal(id:' +
        paramsID +
        '){ id, ' +
        'stepProd { id, intermediateStageNumber, preparation{ ' +
        'associationsProductsHardware{ id, products{ id, stickerId }, quoteArticle{ id, quantity, productReference{ id, wording, supplierHardware{ name, url } } } },' +
        'associationsProductsVirtual{ id, products{ id }, quoteArticle{ id, quantity, productReference{ id, wording, supplierVirtual{ name, url } } } },' +
        ' } } ' +
        '} }';
      queryURL += graphQL;
      this.props
        .authFetch(queryURL, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'GET',
        })
        .then((resp) => resp.json())
        .then(
          function (data) {
            if (data['data']['deal']['stepProd']['preparation']) {
              this.setState({
                dealID: data['data']['deal']['id'],
                dataAssociationHardware:
                  data['data']['deal']['stepProd']['preparation']['associationsProductsHardware'],
                dataAssociationVirtual: data['data']['deal']['stepProd']['preparation']['associationsProductsVirtual'],
              });
            } else {
              this.setState({
                dataAssociationHardware: [],
                dataAssociationVirtual: [],
              });
            }
            //console.log(data);
          }.bind(this)
        )
        .catch(
          function (error) {
            console.log('erreur fetch deal entity: \n' + error);
          }.bind(this)
        );
    }
    ///////////////////////////////////////
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.id != this.props.match.params.id) {
      // Route reloaded
      this.componentDidMount();
    }
  }

  toggleAccordion(id) {
    let accordionMenu = { ...this.state.accordionMenu };
    accordionMenu[id] = !accordionMenu[id];
    this.setState({ accordionMenu });
  }

  render() {
    const { dataAssociationHardware } = this.state;
    const { dataAssociationVirtual } = this.state;

    let noQuoteHardware = '';
    let noQuoteVirtual = '';
    if (this.state.dataAssociationHardware != undefined && this.state.dataAssociationHardware.length == 0) {
      noQuoteHardware = <span>Aucun produit pour cette affaire.</span>;
    }
    if (this.state.dataAssociationVirtual != undefined && this.state.dataAssociationVirtual.length == 0) {
      noQuoteVirtual = <span>Aucun abonnement pour cette affaire.</span>;
    }

    const styles = {
      image: {
        width: '15px',
      },
    };

    let viewName = ' ';
    switch (this.state.selectedView) {
      case 1:
        viewName = 'Produit';
        break;
      case 2:
        viewName = 'Service';
        break;
    }

    return (
      <div id='appView' className='div-entity appPrep'>
        <SubNavBar goBack={this.props.history.goBack} title='Préparation' />

        <div id='appViewContent'>
          <div className='panel-deal-infos'>
            <div className={'timeline ' + 'step' + this.state.currentStep + ' '}>
              <div className='timeline-flex'>
                {stepDetails.map((data, i) => (
                  <div
                    key={i}
                    onClick={(index) => this.viewStep(i + 1)}
                    className={'prep-step-number ' + (this.state.currentStep == i + 1 ? 'selected ' : '')}
                  >
                    <span>{i + 1}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className='alignHorizontal'>
              <span className=''>
                <strong>{stepDetails[this.state.currentStep - 1].name}</strong>
              </span>
            </div>
          </div>

          <div className='helper helper-panel-legend'>
            <span className='helper-label-legend lvl2'>Action requise</span>
            <span className='helper-label-legend lvl1'>En cours</span>
            <button
              onClick={() => this.openModalLinkProduct(true)}
              type='button'
              className='btn btn-sm btn-outline-success'
            >
              <span className='icon icon-hair-cross'>Scan multiple</span>
            </button>
          </div>

          <div className='timeline menu'>
            <div className='timeline-flex'>
              <div
                onClick={(newStep) => this.switchView(1)}
                className={'prep-step-number ' + (this.state.selectedView == 1 ? 'selected' : '')}
              >
                <img style={styles.image} src={hardwareIcon} />
              </div>
              <div
                onClick={(newStep) => this.switchView(2)}
                className={'prep-step-number ' + (this.state.selectedView == 2 ? 'selected' : '')}
              >
                <img style={styles.image} src={virtualIcon} />
              </div>
            </div>
          </div>
          <div className='timeline-step-name'>
            <h3>{viewName}</h3>
          </div>
          {this.state.selectedView == 1 &&
            (dataAssociationHardware ? (
              dataAssociationHardware.map((data, i) => (
                <div>
                  <li
                    className={
                      'list-group-item entity-row spaced ' +
                      (data.quoteArticle.quantity > data.products.length ? 'marked-negative ' : '')
                    }
                    key={data.id}
                  >
                    {data.products.length > 0 && (
                      <button
                        onClick={() => this.toggleAccordion('hardware-' + i)}
                        type='button'
                        className='btn btn-sm btn-outline-success'
                      >
                        <span
                          className={
                            'icon icon-chevron-' + (this.state.accordionMenu['hardware-' + i] ? 'up ' : 'down ')
                          }
                        ></span>
                      </button>
                    )}
                    <span>{data.quoteArticle.productReference.wording}</span>
                    <span>{data.products.length + '/' + data.quoteArticle.quantity}</span>
                    {data.quoteArticle.quantity > data.products.length && (
                      <button
                        onClick={() => this.openModalLinkProduct(false, data)}
                        type='button'
                        className='btn btn-sm btn-outline-success'
                      >
                        <span className='icon icon-plus'></span>
                      </button>
                    )}
                  </li>
                  {this.state.accordionMenu['hardware-' + i] &&
                    (data.products ? (
                      data.products.map((dataProduct) => (
                        <li className='list-group-item entity-row indented-1' key={dataProduct.id}>
                          <Link to={linkToProductHardware + dataProduct.id}>
                            <span className='icon icon-shopping-cart'>{dataProduct.stickerId}</span>
                          </Link>
                          <button
                            onClick={() => this.openModalUnLinkProduct(data.id, dataProduct.id)}
                            type='button'
                            className='btn btn-sm btn-outline-success'
                          >
                            <span className='icon icon-cross'></span>
                          </button>
                        </li>
                      ))
                    ) : (
                      <li className='list-group-item'>Chargement...</li>
                    ))}
                </div>
              ))
            ) : (
              <li className='list-group-item'>Chargement...</li>
            ))}
          {this.state.selectedView == 1 && noQuoteHardware}

          {this.state.selectedView == 2 &&
            (dataAssociationVirtual ? (
              dataAssociationVirtual.map((data, i) => (
                <div>
                  <li className={'list-group-item entity-row spaced '} key={data.id}>
                    <button
                      onClick={() => this.toggleAccordion('virtual-' + i)}
                      type='button'
                      className='btn btn-sm btn-outline-success'
                    >
                      <span
                        className={'icon icon-chevron-' + (this.state.accordionMenu['virtual-' + i] ? 'up ' : 'down ')}
                      ></span>
                    </button>
                    <span>{data.quoteArticle.productReference.wording}</span>
                    <span>{data.quoteArticle.quantity}</span>
                  </li>
                  {this.state.accordionMenu['virtual-' + i] &&
                    (data.quoteArticle.quantity <= itemsPerPage['association_product'] ? (
                      data.products ? (
                        data.products.map((dataProduct) => (
                          <li className='list-group-item entity-row indented-1' key={dataProduct.id}>
                            <Link to={linkToProductVirtual + dataProduct.id}>
                              <span className='icon icon-shopping-cart'>{'#' + dataProduct.id}</span>
                            </Link>
                          </li>
                        ))
                      ) : (
                        <li className='list-group-item'>Chargement...</li>
                      )
                    ) : (
                      <span>
                        Cette article a une quantité supérieure à {itemsPerPage['association_product']} unités.
                      </span>
                    ))}
                </div>
              ))
            ) : (
              <li className='list-group-item'>Chargement...</li>
            ))}
          {this.state.selectedView == 2 && noQuoteVirtual}
        </div>

        <ModalLinkProductToOrder
          isScanMultiple={this.state.isScanMultiple}
          linkRefId={this.state.modalLinkRefId}
          linkWording={this.state.modalLinkWording}
          dealId={this.props.match.params.id}
          openToast={(success, message) => this.props.openToast(success, message)}
          className='myModal'
          isOpen={this.state.isModalLinkProductOpen}
          onPost={this.link}
          onClose={this.closeModal}
        ></ModalLinkProductToOrder>

        <ModalConfirm
          className='myModal'
          modalText={this.state.textModal}
          isOpen={this.state.isModalUnLinkProductOpen}
          onSubmit={() => this.unLinkProduct()}
          onClose={() => this.closeModal()}
          onCancel={() => this.closeModal()}
        ></ModalConfirm>
      </div>
    );
  }

  openModalUnLinkProduct(assocId, productId) {
    let modal = {
      title: 'Retirer produit',
      message: 'Vous allez retirer le produit de cette commande',
    };
    this.props.toggleBlackOut();
    this.setState({
      textModal: modal,
      isModalUnLinkProductOpen: true,
      unLinkAssocId: assocId,
      unLinkProductId: productId,
    });
  }

  openModalLinkProduct(isMultiple, assoc = undefined) {
    if (assoc) {
      this.setState({
        assocLinkId: assoc.id,
        modalLinkRefId: assoc.quoteArticle.productReference.id,
        modalLinkWording: assoc.quoteArticle.productReference.wording,
      });
    }
    this.props.toggleBlackOut();
    this.setState({
      isScanMultiple: isMultiple,
      isModalLinkProductOpen: true,
    });
  }

  unLinkProduct() {
    if (this.state.unLinkAssocId && this.state.unLinkProductId) {
      // check if id supplied in the route
      let queryURL = apiProductUnLink;
      let json = {
        association: {
          id: this.state.unLinkAssocId,
        },
        product: {
          id: this.state.unLinkProductId,
        },
      };
      queryURL += encodeURIComponent(JSON.stringify(json));
      this.props
        .authFetch(queryURL, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'DELETE',
        })
        .then((resp) => resp.json())
        .then(
          function (data) {
            if (data['isValid'] == true) {
              this.props.openToast(true, 'Produit dissocié de la commande');
              this.componentDidMount();
            } else {
              this.props.openToast(false, 'Erreur suppression. Veuillez réessayer');
            }
            //console.log(data);
          }.bind(this)
        )
        .catch(
          function (error) {
            console.log('erreur fetch Product entity');
          }.bind(this)
        );
    } else {
      console.log('Error. No product selected');
    }
  }

  link(param) {
    if (this.state.isScanMultiple) {
      this.linkProducts(param);
    } else {
      this.linkProduct(param);
    }
  }

  linkProducts(productList) {
    if (this.props.match.params.id) {
      // check if id supplied in the route
      let queryURL = apiProductsLink;
      let json = {
        deal: {
          id: this.props.match.params.id,
          products: productList,
        },
      };
      let data = 'data=' + encodeURIComponent(JSON.stringify(json));
      this.props
        .authFetch(queryURL, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          method: 'POST',
          body: data,
        })
        .then((resp) => resp.json())
        .then(
          function (data) {
            if (data['isValid'] == true) {
              this.props.openToast(true, 'Les produits valides ont été associés à la commande');
              this.componentDidMount();
            } else {
              this.props.openToast(false, 'Erreur ajout produit. Veuillez réessayer');
            }
            //console.log(data);
          }.bind(this)
        )
        .catch(
          function (error) {
            console.log('error fetch Assoc Product');
          }.bind(this)
        );
    } else {
      console.log('Error. No association selected');
    }
  }

  linkProduct(productId) {
    if (this.state.assocLinkId) {
      // check if id supplied in the route
      let queryURL = apiProductLink;
      let json = {
        association: {
          id: this.state.assocLinkId,
          products: [
            // BACK ask for an array
            {
              id: productId,
            },
          ],
        },
      };
      queryURL += encodeURIComponent(JSON.stringify(json));
      this.props
        .authFetch(queryURL, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'POST',
        })
        .then((resp) => resp.json())
        .then(
          function (data) {
            if (data['isValid'] == true) {
              this.props.openToast(true, 'Produit associé à la commande');
              this.componentDidMount();
            } else {
              this.props.openToast(false, 'Erreur ajout produit. Veuillez réessayer');
            }
            //console.log(data);
          }.bind(this)
        )
        .catch(
          function (error) {
            console.log('error fetch Assoc Product');
          }.bind(this)
        );
    } else {
      console.log('Error. No association selected');
    }
  }

  closeModal() {
    this.props.toggleBlackOut();
    this.setState({
      isModalLinkProductOpen: false,
      isModalUnLinkProductOpen: false,
    });
  }

  switchView(newStep) {
    this.setState({
      selectedView: newStep,
    });
  }

  viewStep(index) {
    if (this.state.currentStep != index) {
      this.setState({
        currentStep: index,
      });
    }
  }
}

export default withAuth(AppPrep);
